module.exports = __webpack_public_path__ + "img/NukedTV-Web_38.b15ac30d.png";